import { KEYS } from 'game/constants/SceneConstants';
import { SceneBase } from '@jollywise/jollygoodgame';
import { DisplayOutcomeScore } from 'game/display/DisplayOutcomeScore';
import { FONT_BASE } from 'game/constants/AppFonts';
import { ButtonSimple } from '@jollywise/jollygoodgame';
import { trackCurrentScenario } from 'game/utils/GaTracking';

export class ScenarioOutcome extends SceneBase {
  constructor() {
    super({ key: KEYS.ScenarioOutcome, active: false });
  }
  create() {
    super.create();
    this.setBackgroundColour(0x0069b5);
    this.bg = this.add.image(0, 0, 'backgrounds', 'background_home').setOrigin(0);

    this.game.hud.setState('GAME');

    this.topLine = this.add.rectangle(840, 140, 800, 2, 0xffffff).setOrigin(0.5, 0);

    // get data from players choice
    this._outcomeData = this.game._scenario.getCurrentScenarioPlayersChoiceData;

    this.add
      .text(
        this.topLine.x - this.topLine.width / 2,
        this.topLine.y - 10,
        this.game._scenario.getCurrentScenarioTitle,
        {
          fontFamily: FONT_BASE.CALIBRE_BOLD,
          fontSize: '64px',
          color: '#ffffff',
        }
      )
      .setOrigin(0, 1);

    this.resultsBg = this.add.image(0, 168, 'backgrounds', 'background_score_result').setOrigin(0);
    this.resultsBg.alpha = 0;

    this.add.tween({
      targets: this.resultsBg,
      alpha: 1,
      duration: 500,
      ease: Phaser.Math.Easing.Back.In,
      onComplete: () => {
        this.displayOutcomeData();
      },
    });

    const playersData = this.game._player.getLastScenarioPlayed;
    console.log(playersData);
    const { scenarios_id, documents_read = [], players_choice } = playersData;

    trackCurrentScenario({
      scenario_id: scenarios_id,
      scenario_title: this.game._scenario.getCurrentScenarioTitle,
      documents_read: documents_read,
      players_choice: players_choice,
      current_time: this.game._player.currentTime.time,
    });
  }

  displayOutcomeData() {
    // display outcome data
    // this._outcomeData

    const { title = '', desc = '' } = this._outcomeData?.result || {};

    this.resultTitle = this.add
      .text(840, this.resultsBg.y + 28, title, {
        fontFamily: FONT_BASE.CALIBRE_BOLD,
        fontSize: '64px',
        color: '#ffffff',
        wordWrap: { width: 800 },
        align: 'center',
      })
      .setOrigin(0.5, 0);
    this.resultTitle.alpha = 0;

    this.resultBody = this.add
      .text(840, this.resultTitle.y + this.resultTitle.height + 20, desc, {
        fontFamily: FONT_BASE.CALIBRE_REGULAR,
        fontSize: '30px',
        color: '#ffffff',
        wordWrap: { width: 800 },
        align: 'center',
      })
      .setOrigin(0.5, 0);
    this.resultBody.alpha = 0;

    this.add.tween({
      targets: [this.resultTitle, this.resultBody],
      alpha: 1,
      duration: 500,
      ease: Phaser.Math.Easing.Back.In,
      onComplete: () => {
        this.displayScores();
      },
    });
  }

  displayScores() {
    this.scoresContainer = this.add.container(840, 430);
    this.scoresContainer.alpha = 0;

    const scores = this.game._scores.getScores;
    const outcomeScores = this._outcomeData?.scores || [];

    outcomeScores.map((data, index) => {
      const { type, score } = data;

      const scoreProgress = new DisplayOutcomeScore(this, {
        x: 840,
        y: 0,
        type,
        score,
      });

      scoreProgress.x = scoreProgress.width * index + 20 * index;
      this.scoresContainer.add(scoreProgress);
    });

    this.scoresContainer.x -= outcomeScores.length >= 2 ? 100 * (outcomeScores.length - 1) : 0;

    this.add.tween({
      targets: this.scoresContainer,
      alpha: 1,
      duration: 300,
      ease: Phaser.Math.Easing.Back.In,
      onComplete: () => {
        this.game.soundController.playSFX('sfx', 'chn_outcome');

        this.displayContinueButton();
      },
    });
  }

  displayContinueButton() {
    this.continue = new ButtonSimple(this, {
      x: 840,
      y: this.game.defaultHeight - 40,
      id: 'btn_continue',
      costume: 'btn_continue',
    }).setOrigin(0.5, 1);
    this.continue.alpha = 0;

    this.add.tween({
      targets: this.continue,
      alpha: 1,
      duration: 300,
      ease: Phaser.Math.Easing.Back.In,
      onComplete: () => {
        this.continue.on('pointerdown', this.handleContinueClick, this);
      },
    });
  }

  handleContinueClick() {
    this.game.soundController.playSFX('sfx', 'chn_button_click');

    this.game._player.updateCurrentTime();

    // check if player has reached time progress limit or has reached zero for any score metric
    // if so, go to game result scene
    const displayResultScene =
      this.game._player.playerHasReachehdEndOfTime() || this.game._scores.scoreHasReachedZero();

    // otherwise, go to scenario scene
    if (displayResultScene) {
      this.game.outroScene();
      return;
    }

    // check if there is another scenario to play
    const hasNextScenario = this.game._scenario.getRandomScenario();

    // reset players choice
    this.game._scenario.resetPlayersChoice();

    // if no more scenarios, go to game result scene
    hasNextScenario ? this.game.sceneController.switchScene(KEYS.Scenario) : this.game.outroScene();
  }
}
